import { FormLabel } from '@admin-platform/ui/components';

export const Label = FormLabel;
